module.exports = __webpack_public_path__ + "assets/img/c16d9bd23415a1372e1061c0d8088f81.svg";